import React from 'react';
import styled from 'styled-components';
import { FaSpinner } from 'react-icons/fa';
import { rotate } from '../keyframes/rotations';

const StyledSpinner = styled(FaSpinner)`
	color: ${props => (props.color ? props.color : props.theme.colors.primary)};
	animation: ${rotate} 1s infinite linear;
`;

const Spinner = () => {
	return (
		<StyledSpinner />
	);
};

export default Spinner;
